/**
 * HealthAlertIcon — sanitized from `assets/newSvg/health-alert.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function HealthAlertIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M12,2 C17.5228,2 22,6.47715 22,12 C22,17.5228 17.5228,22 12,22 C6.47715,22 2,17.5228 2,12 C2,6.47715 6.47715,2 12,2 Z M12,16 C11.4477,16 11,16.4477 11,17 C11,17.5523 11.4477,18 12,18 C12.5523,18 13,17.5523 13,17 C13,16.4477 12.5523,16 12,16 Z M12,6.5 C9.99797,6.5 8.375,8.12297 8.375,10.125 C8.375,10.6773 8.82272,11.125 9.375,11.125 C9.92728,11.125 10.375,10.6773 10.375,10.125 C10.375,9.22754 11.1025,8.5 12,8.5 C12.8975,8.5 13.625,9.22754 13.625,10.125 C13.625,10.8073 13.2042,11.3937 12.6042,11.6343 C11.9293,11.9048 11,12.5971 11,13.75 L11,14 C11,14.5523 11.4477,15 12,15 C12.5523,15 13,14.5523 13,14 C13,13.7562667 13.0493827,13.6338963 13.2611534,13.5292949 L13.3484,13.4907 C14.681,12.9564 15.625,11.6522 15.625,10.125 C15.625,8.12297 14.002,6.5 12,6.5 Z"
        fill={color}
      />
    </Svg>
  );
}

export default HealthAlertIcon;
